import React, { useState, useEffect } from "react";
import { useParams, useHistory, Link } from "react-router-dom";
// import CategoryGames from "elements/games_elements/CategoryGames";
import api from "services/api";
// import auth from "services/auth";
// import AppContext from "contexts/AppContext";
// import emailValidate from "services/emailValidate";
// import ls from "local-storage";
import swal from "sweetalert";
import { Modal, Button } from "react-bootstrap";
// import VipLevelText from "elements/VipLevelText";
// import SingleCategoryGames from "elements/games_elements/SingleCategoryGames";
import { __ } from "services/Translator";
import SearchBox from "elements/SearchBox";
import GameDetails from "elements/games_elements/GameDetails";

export default function GamePlay(props) {
  // game details tab
  const [gameDetailsTab, setGameDetailsTab] = useState("Game Description");

  // bets  tab

  const [betsTab, setBetsTab] = useState("Big Bets");

  const [gameList, setGameList] = useState([]);
  const [gameSorting, setGameSorting] = useState(null);

  const getGameList = async () => {
    props.setSpinner(true);
    var response = await api.post("/games/by-category", {
      per_page: 12,
      game_types: ["popular"],
      page: 1,
      game_sorting: gameSorting,
      providers: props.selectedProviders,
    });
    props.setSpinner(false);
    if (response.status === 200) {
      setGameList(response.data.games?.popular?.gamelist ?? []);
    }
  };

  // const __ = (text) => text;

  useEffect(() => {
    getGameList();
  }, [gameSorting, props.selectedProviders]);

  const params = useParams();
  const history = useHistory();
  const isAuthenticated = props.isAuthenticated;
  const [launchUrl, setLaunchUrl] = useState("");
  const [gameDetails, setGameDetails] = useState("");
  const gamePlayMode = params.mode && params.mode === "demo" ? "demo" : "real";
  const [gameSessionId, setGameSessionId] = useState(null);

  const setGamePlayMode = (mode) => {
    if (mode === "demo") {
      history.replace("/play/" + params.slug + "/demo");
    } else {
      history.replace("/play/" + params.slug);
    }
  };

  const toggleFullScreen = () => {
    if (
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement
    ) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    } else {
      var element = document.getElementById("game_play_window");
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
    }
  };

  const iframeSrcChanged = (event) => {
    // alert(event.target.contentWindow.location);
  };

  const getPlay = async () => {
    var response = await api.post("/game/initsession", {
      slug: params.slug,
      mode: gamePlayMode,
    });

    if (response.status === 200 && response.data) {
      setLaunchUrl(response.data.launchUrl);
      setGameSessionId(response.data.sessionId);
      setGameDetails(response.data.details);
    } else {
      swal({
        // title: "Are you sure?",
        text: response.data.message,
        type: "warning",
        icon: "warning",
        confirmButtonText: "Ok",
      }).then((result) => {
        history.push("/games/all");
        props.setModalLoginPropsData(true);
      });
    }
  };

  useEffect(() => {
    getPlay();
  }, [gamePlayMode, params.slug]);

  const [bonusUnsupportedWarningModal, setBonusUnsupportedWarningModal] =
    useState({ show: false });

  useEffect(() => {
    if (
      gameDetails &&
      props.userBalance &&
      gamePlayMode !== "demo" &&
      !gameDetails.bonus_supported &&
      parseFloat(props.userBalance.cash_balance) === 0.0
    ) {
      setBonusUnsupportedWarningModal({ show: true });
    } else {
      setBonusUnsupportedWarningModal({ show: false });
    }
  }, [gamePlayMode, props.userBalance.cash_balance, gameDetails]);

  const closeAllModals = () => {
    setGameHubMessageModal({ show: false });
    setBonusUnsupportedWarningModal({ show: false });
  };

  //GameHub message functionality
  const [gameHubMessageModal, setGameHubMessageModal] = useState({
    title: "",
    message: "",
    show: false,
  });

  const loadGameHubMessage = async () => {
    var response = await api.post("/load-game-hub_message", {
      provider: gameDetails.game_aggregator,
      game_session_id: gameSessionId,
    });
    if (response.status === 200) {
      if (response.data.type == "found") {
        //There is a message to show.
        var modalData = {
          ...modalData,
          show: true,
          title: "Warning!!",
          message: response.data.gamehub_message.message,
          message_type: response.data.gamehub_message.message_type,
        };

        setGameHubMessageModal(modalData);
      } else if (response.data.type == "session_created") {
        //Session type changed. Message to show and game area to reload
        setGameHubMessageModal({
          ...gameHubMessageModal,
          message_type: response.data.gamehub_message.message_type,
          title: __("Balance type changed!"),
          message: response.data.gamehub_message.message,
          show: true,
        });
        setGameSessionId(response.data.newSession.sessionId);
        setLaunchUrl(response.data.newSession.launchUrl);
      }
    }
  };

  useEffect(() => {
    var interval = setInterval(function () {
      if (gamePlayMode !== "demo") {
        loadGameHubMessage();
      }
    }, 10000);

    return () => {
      clearInterval(interval);
    };
  }, [gameSessionId, gameDetails, isAuthenticated, gamePlayMode]);

  //GamePlay Page detection
  const isMobileDevice = props.isMobileDevice;
  const isMobileDeviceByViewPort = props.isMobileDeviceByViewPort;
  const isLandscape = props.isLandscape;
  const [mobileIframeStyle, setMobileIframeStyle] = useState({});
  const calclateMobileIframeStyle = () => {
    var style = {
      width: "100vw",
      height: "calc(100vh - 52px)",
      // height: "100vh",
    };
    if (isLandscape) {
      style.height = "100vh";
    }
    setMobileIframeStyle(style);
  };

  useEffect(() => {
    window.addEventListener("resize", () => {
      calclateMobileIframeStyle();
    });
    calclateMobileIframeStyle();

    window.gotoGamesPage = () => {
      history.push("/");
    };
  }, []);

  const [topWinners, setTopWinners] = useState([]);

  const getTopWinners = async () => {
    var response = await api.get("/games/top-winners?limit=4");
    if (response.status === 200) {
      setTopWinners(response.data.data);
    } else {
      // console.log(response.data);
    }
  };

  useEffect(() => {
    getTopWinners();
  }, []);
  const [theaterMode, setTheaterMode] = useState(false);

  const [isFavorite, setIsFavorite] = useState(gameDetails.is_favorite_game);
  const toggleFavoriteGame = async () => {
    var response = await api.post("/toggle-favorite-game", {
      gameId: gameDetails.id,
    });
    if (response.status === 200) {
      if (response.data.status === "added") {
        setIsFavorite(true);
      } else {
        setIsFavorite(false);
      }
    }
  };

  //RTP Info
  const [showRTPModal, setShowRTPModal] = useState(false);

  return (
    <>
      {!isMobileDeviceByViewPort && (
        <div className="game_play_page">
          <>
            <section className="game_play">
              <div
                className={"container " + (theaterMode ? "theaterMode" : "")}
              >
                <div className="game_play_frame">
                  {!launchUrl && (
                    <img
                      className="game_preview_img"
                      alt="Game image"
                      src="https://chimpbytes.imgix.net/games-details.png?&dpr=3&format=auto&auto=format&q=50&w=1296&h=715&max-age=2629056"
                    />
                  )}

                  <div className="game_content">
                    <iframe
                      style={{ display: "block !important;" }}
                      id="game_play_window"
                      width="100%"
                      height="700"
                      src={launchUrl}
                    ></iframe>
                    <div className="game_play_overlay"></div>
                  </div>

                  <div className="game_actions">
                    <div className="left_section">
                      {/* <Button className="action_btn">
                        <i class="fas fa-pause"></i>
                      </Button>
                      <Button className="action_btn">
                        <i class="fas fa-volume"></i>
                      </Button> */}
                      {gamePlayMode != "demo" && (
                        <button className="action_btn">
                          <i
                            class={"fas fa-circle shadow " + props.landingType}
                          ></i>{" "}
                          {__("Live")}
                        </button>
                      )}
                    </div>
                    <div className="search searchbox">
                      <SearchBox {...props} />
                    </div>
                    <div className="left_section">
                      <button
                        onClick={() => {
                          setShowRTPModal(true);
                        }}
                        className={
                          "action_btn color_theme " + props.landingType
                        }
                      >
                        <svg
                          version="1.1"
                          id="Capa_1"
                          xmlns="http://www.w3.org/2000/svg"
                          xlink="http://www.w3.org/1999/xlink"
                          height="15"
                          width="15"
                          viewBox="0 0 512 512"
                          space="preserve"
                        >
                          <g>
                            <g>
                              <path
                                d="M33,362.371v78.9c0,4.8,3.9,8.8,8.8,8.8h61c4.8,0,8.8-3.9,8.8-8.8v-138.8l-44.3,44.3
			C57.9,356.071,45.9,361.471,33,362.371z"
                              />
                              <path d="M142,301.471v139.8c0,4.8,3.9,8.8,8.8,8.8h61c4.8,0,8.8-3.9,8.8-8.8v-82.3c-13.9-0.3-26.9-5.8-36.7-15.6L142,301.471z" />
                              <path
                                d="M251,350.271v91c0,4.8,3.9,8.8,8.8,8.8h61c4.8,0,8.8-3.9,8.8-8.8v-167.9l-69.9,69.9
			C257,345.971,254.1,348.271,251,350.271z"
                              />
                              <path
                                d="M432.7,170.171l-72.7,72.7v198.4c0,4.8,3.9,8.8,8.8,8.8h61c4.8,0,8.8-3.9,8.8-8.8v-265.6c-2-1.7-3.5-3.2-4.6-4.2
			L432.7,170.171z"
                              />
                              <path
                                d="M482.6,41.371c-2.9-3.1-7.3-4.7-12.9-4.7c-0.5,0-1.1,0-1.6,0c-28.4,1.3-56.7,2.7-85.1,4c-3.8,0.2-9,0.4-13.1,4.5
			c-1.3,1.3-2.3,2.8-3.1,4.6c-4.2,9.1,1.7,15,4.5,17.8l7.1,7.2c4.9,5,9.9,10,14.9,14.9l-171.6,171.7l-77.1-77.1
			c-4.6-4.6-10.8-7.2-17.4-7.2c-6.6,0-12.7,2.6-17.3,7.2L7.2,286.871c-9.6,9.6-9.6,25.1,0,34.7l4.6,4.6c4.6,4.6,10.8,7.2,17.4,7.2
			s12.7-2.6,17.3-7.2l80.7-80.7l77.1,77.1c4.6,4.6,10.8,7.2,17.4,7.2c6.6,0,12.7-2.6,17.4-7.2l193.6-193.6l21.9,21.8
			c2.6,2.6,6.2,6.2,11.7,6.2c2.3,0,4.6-0.6,7-1.9c1.6-0.9,3-1.9,4.2-3.1c4.3-4.3,5.1-9.8,5.3-14.1c0.8-18.4,1.7-36.8,2.6-55.3
			l1.3-27.7C487,49.071,485.7,44.571,482.6,41.371z"
                              />
                            </g>
                          </g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                        </svg>
                      </button>
                      {/* <Button className="action_btn">
                        <i class="fas fa-cog"></i>
                      </Button> */}
                      <button
                        title="Theatre Mode"
                        onClick={() => {
                          setTheaterMode(!theaterMode);
                        }}
                        className="action_btn"
                      >
                        <svg
                          width="15px"
                          height="15px"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M5,22 C3.34314575,22 2,20.6568542 2,19 L2,5 C2,3.34314575 3.34314575,2 5,2 L19,2 C20.6568542,2 22,3.34314575 22,5 L22,19 C22,20.6568542 20.6568542,22 19,22 L5,22 Z M11,4 L5,4 C4.44771525,4 4,4.44771525 4,5 L4,19 C4,19.5522847 4.44771525,20 5,20 L11,20 L11,4 Z M19,4 L13,4 L13,20 L19,20 C19.5522847,20 20,19.5522847 20,19 L20,5 C20,4.44771525 19.5522847,4 19,4 Z"
                          />
                        </svg>
                      </button>

                      <button
                        onClick={toggleFullScreen}
                        title="Full Screen"
                        className="action_btn"
                      >
                        <i class="fas fa-expand"></i>
                      </button>
                    </div>
                  </div>

                  {!launchUrl && (
                    <div className="authentications">
                      <button
                        onClick={() => {
                          props.setModalSignUpPropsData(true);
                        }}
                        className={
                          "angle_btn active small " + props.landingType
                        }
                      >
                        {__("Register")}
                      </button>
                      <button
                        className={
                          "angle_btn active small " + props.landingType
                        }
                      >
                        {" "}
                        {__("Play for Fun")}{" "}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </section>
            <GameDetails gameDetails={gameDetails} {...props} />
          </>
        </div>
      )}

      {isMobileDeviceByViewPort && (
        <iframe
          onLoad={iframeSrcChanged}
          src={launchUrl}
          style={mobileIframeStyle}
        />
      )}

      <Modal
        className="gamePlayMsgModal"
        show={gameHubMessageModal.show}
        onHide={closeAllModals}
        centered
      >
        {/* <Modal className="gamePlayMsgModal" show={1} onHide={closeAllModals}> */}
        <Modal.Header>
          <h5 className="modal-title" id="exampleModalLabel">
            {gameHubMessageModal.message_type == "maximum_cash_wagers_per_round"
              ? __("Maximum cash wager limit exceeded!")
              : gameHubMessageModal.message_type ==
                "maximum_bonus_wagers_per_round"
              ? __("Maximum bonus wagers limit exceeded!")
              : gameHubMessageModal.message_type == "bonus_balance_not_support"
              ? __("Insufficient balance!")
              : gameHubMessageModal.message_type == "maximum_wagers"
              ? __("Maximum cash wager limit exceeded!")
              : gameHubMessageModal.message_type == "maximum_loss"
              ? __("Maximum cash loss limit exceeded!")
              : gameHubMessageModal.message_type == "maximum_playing_time"
              ? __("Maximum play time limit exceeded!")
              : gameHubMessageModal.title}
          </h5>
          {/* <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={closeAllModals}
          >
            <span aria-hidden="true">&times;</span>
          </button> */}
        </Modal.Header>
        <Modal.Body className="login_modal forgot_pass">
          <div className="game_message_content">
            <i class="fas fa-exclamation-triangle"></i>
            <br />
            {gameHubMessageModal.message_type ==
            "maximum_cash_wagers_per_round" ? (
              <>
                {__(
                  "You have exceeded the maximum bet amount for cash money. Please lower the amount and try again. See our"
                )}
                <Link to="">{__("General Terms & Conditions")}</Link>{" "}
                {__("for more information.")}"
              </>
            ) : gameHubMessageModal.message_type ==
              "maximum_bonus_wagers_per_round" ? (
              <>
                {__(
                  "You have exceeded the maximum bet amount for bonus money. Please lower the amount and try again. See our"
                )}
                <Link to="">{__("Bonus Terms")}</Link>{" "}
                {__("for more information.")}
              </>
            ) : gameHubMessageModal.message_type ==
              "bonus_balance_not_support" ? (
              <>
                {__(
                  "Bonus play is not supported for this game. You do not have sfficient cash balance to play this game. See our"
                )}
                <Link to="">{__("Bonus Terms")}</Link>{" "}
                {__(
                  "for more information. Note: For Live Casino games and Sports Betting, Only cash wagers are accepted (no bonus wagers)"
                )}
              </>
            ) : (
              <>{gameHubMessageModal.message}</>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="common_btn" onClick={closeAllModals}>
            {__("OK")}
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        className="gamePlayMsgModal"
        show={bonusUnsupportedWarningModal.show}
        onHide={closeAllModals}
        centered
      >
        <Modal.Header>
          <h5 className="modal-title" id="exampleModalLabel">
            {__("Game playing with bonus money!")}
          </h5>
          {/* <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={closeAllModals}
          >
            <span aria-hidden="true">&times;</span>
          </button> */}
        </Modal.Header>
        <Modal.Body className="login_modal forgot_pass">
          <div className="game_message_content">
            <p className="padding_bottom_15">
              {__(
                "This game is not available for bonus money. Only cash money is accepted."
              )}
            </p>
            <p className="padding_bottom_15">
              {__(
                "Note: All Live Casino games are not available for bonus money wagering."
              )}
            </p>
            <Link to="/bonus">{__("Click here")}</Link>{" "}
            {__("to see which games are available for Bonus Money playing.")}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="common_btn" onClick={closeAllModals}>
            {__("OK")}
          </button>
        </Modal.Footer>
      </Modal>

      {/* RTP Modal */}
      <Modal
        size="sm"
        show={showRTPModal}
        onHide={() => setShowRTPModal(false)}
        aria-labelledby="example-modal-sizes-title-sm"
        className="rtpPopup"
        centered
      >
        <Modal.Body>
          <i onClick={() => setShowRTPModal(false)} class="fas fa-times"></i>
          <div className="rtpPopupContent">
            <div className="rtpPopupText">RTP: {gameDetails.rtp}%</div>
            <svg
              version="1.1"
              id="Capa_1"
              xmlns="http://www.w3.org/2000/svg"
              xlink="http://www.w3.org/1999/xlink"
              height="150"
              width="150"
              viewBox="0 0 512 512"
              space="preserve"
            >
              <g>
                <g>
                  <path
                    d="M33,362.371v78.9c0,4.8,3.9,8.8,8.8,8.8h61c4.8,0,8.8-3.9,8.8-8.8v-138.8l-44.3,44.3
			C57.9,356.071,45.9,361.471,33,362.371z"
                  />
                  <path d="M142,301.471v139.8c0,4.8,3.9,8.8,8.8,8.8h61c4.8,0,8.8-3.9,8.8-8.8v-82.3c-13.9-0.3-26.9-5.8-36.7-15.6L142,301.471z" />
                  <path
                    d="M251,350.271v91c0,4.8,3.9,8.8,8.8,8.8h61c4.8,0,8.8-3.9,8.8-8.8v-167.9l-69.9,69.9
			C257,345.971,254.1,348.271,251,350.271z"
                  />
                  <path
                    d="M432.7,170.171l-72.7,72.7v198.4c0,4.8,3.9,8.8,8.8,8.8h61c4.8,0,8.8-3.9,8.8-8.8v-265.6c-2-1.7-3.5-3.2-4.6-4.2
			L432.7,170.171z"
                  />
                  <path
                    d="M482.6,41.371c-2.9-3.1-7.3-4.7-12.9-4.7c-0.5,0-1.1,0-1.6,0c-28.4,1.3-56.7,2.7-85.1,4c-3.8,0.2-9,0.4-13.1,4.5
			c-1.3,1.3-2.3,2.8-3.1,4.6c-4.2,9.1,1.7,15,4.5,17.8l7.1,7.2c4.9,5,9.9,10,14.9,14.9l-171.6,171.7l-77.1-77.1
			c-4.6-4.6-10.8-7.2-17.4-7.2c-6.6,0-12.7,2.6-17.3,7.2L7.2,286.871c-9.6,9.6-9.6,25.1,0,34.7l4.6,4.6c4.6,4.6,10.8,7.2,17.4,7.2
			s12.7-2.6,17.3-7.2l80.7-80.7l77.1,77.1c4.6,4.6,10.8,7.2,17.4,7.2c6.6,0,12.7-2.6,17.4-7.2l193.6-193.6l21.9,21.8
			c2.6,2.6,6.2,6.2,11.7,6.2c2.3,0,4.6-0.6,7-1.9c1.6-0.9,3-1.9,4.2-3.1c4.3-4.3,5.1-9.8,5.3-14.1c0.8-18.4,1.7-36.8,2.6-55.3
			l1.3-27.7C487,49.071,485.7,44.571,482.6,41.371z"
                  />
                </g>
              </g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
            </svg>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
